import { BeneficiaryFilterBooleanType, NULL_AS_STRING } from '@repo/shared/dtos/beneficiary'
import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { RadioGroup, RadioGroupItem } from '@repo/ui/radio-group'
import { useState } from 'react'

import { FilterFormProps } from './types'

export default function BooleanFilterForm(props: FilterFormProps<BeneficiaryFilterBooleanType>) {
  const { filter, onChange, onCancel } = props

  const [form, setForm] = useState<BeneficiaryFilterBooleanType>(filter)
  const { t } = useT({ keyPrefix: 'beneficiary.filters' })

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onCancel()
    onChange(form)
  }

  return (
    <form
      onSubmit={(event) => {
        handleSubmit(event)
      }}
      className="min-w-44 space-y-6"
    >
      <RadioGroup
        value={form.value === null ? NULL_AS_STRING : form.value ? 'true' : 'false'}
        onValueChange={(value) =>
          setForm({ ...form, value: value === NULL_AS_STRING ? null : value === 'true' })
        }
      >
        <div className="flex items-center gap-4">
          <label className="flex items-center gap-2">
            <RadioGroupItem value="true" />
            <span className="text-primary-500 dark:text-primary-400 cursor-pointer text-sm uppercase">
              {t('boolean.true')}
            </span>
          </label>
          <label className="flex items-center gap-2">
            <RadioGroupItem value="false" />
            <span className="text-primary-500 dark:text-primary-400 cursor-pointer text-sm uppercase">
              {t('boolean.false')}
            </span>
          </label>
          <label className="flex items-center gap-2">
            <RadioGroupItem value={NULL_AS_STRING} />
            <span className="text-primary-500 dark:text-primary-400 cursor-pointer text-sm uppercase">
              {t('boolean.null')}
            </span>
          </label>
        </div>
      </RadioGroup>

      <div className="flex justify-end gap-2">
        <Button type="button" onClick={onCancel} variant="ghost">
          {t('form.cancelButton')}
        </Button>
        <Button type="submit">{t('form.applyButton')}</Button>
      </div>
    </form>
  )
}
